<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
  },
};
</script>

<style lang="less">
@px:1 /19.2vw;
@media screen and (max-width: 1366px) {
  .el-checkbox__label {
    font-size: 12px !important;
  }
  html {
    font-size: 13.66px !important;
  }
}
* {
  /* font-family: 'Normal'; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  text-decoration: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 19.2px;
}

.login_btn,
.go_study,
.close_bg,
.research_propup_close,
.go_back,
.back_to_home,
.advanced_course,
.curriculum_btn,
.erji,
.study_back,
.catalog:hover {
  cursor: pointer;
}
li {
  // list-style: none;
}
.el-progress__text {
  color: #000 !important;
}
.study_content
  > .con_tainer
  > .main_content
  > .right
  > .prog
  > .el-progress-circle
  > .el-progress__text {
  color: #fff !important;
}
.el-textarea__inner {
  height: 120px;
  text-align: left !important;
  margin-top: 12px;
  background: #182838;
  border: none;
  padding: 18px 20px;
  font-size: 20px;
  color: #ffffff;
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  font-size: 16px;
  color: #999999 !important;
}
input:-moz-placeholder,
textarea:-moz-placeholder {
  font-size: 16px;
  color: #999999 !important;
}
input::-moz-placeholder,
textarea::-moz-placeholder {
  font-size: 16px;
  color: #999999 !important;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  font-size: 16px;
  color: #999999 !important;
}
.input_content input::-webkit-input-placeholder {
  font-size: 18px !important;
  color: #cccccc !important;
  font-family: Medium;
}
.input_content .el-input__inner {
  font-size: 18px;
  color: #333;
}
.el-input.is-disabled .el-input__inner {
  color: #333;
}
.el-submenu__icon-arrow {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #000 !important;
}
a {
  text-decoration: none;
}
button {
  border: none;
  outline: none;
}

.el-header,
.el-main,
.el-footer {
  padding: 0;
}

body {
  width: 100%;
  height: 100%;
}
.el-checkbox__label {
  color: #ccc !important;
}
/* 修改课程内容的关键字样式 */
.keyword {
  background: #34333c;
  color: #ffffff;
  padding: 0.16vw 0.6vw;
  margin: 0.1vw 0.2vw;
  border-radius: 0.3vw;
  display: inline-block;
  word-break: break-all;
}
input {
  outline: none;
}
.el-input__inner {
  text-align: left;
}
.van-picker-column {
  margin-top: 10px;
}
.viewer-footer {
  display: none;
}
.viewer-button {
  top: 6% !important;
  right: 1% !important;
  background: transparent !important;
}
.viewer-close::before {
  width: 30px !important;
  height: 30px !important;
  background: url("../src/assets/close.png") !important;
  background-size: 100% 100% !important;
}
.viewer-button:hover {
  background: transparent !important;
}

p > img {
  width: 100%;
  height: 100%;
  vertical-align: top;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ff5800;
  border-color: #ff5800;
}
.el-checkbox__inner:hover {
  border-color: #ff5800;
}

/* 首页轮播图 */
.banner {
  width: 630 * @px;
  height: 1100 * @px;

  overflow: hidden;
  margin: auto;
}
.el-carousel__container {
  height: 1036 * @px !important;
  margin-top: 35px;
}
.el-carousel__indicators {
  display: none;
}

.answer_btns .el-checkbox__label {
  font-size: 16px !important;
  color: #333333;
  padding-left: 5px;
}
.answer_btns .el-checkbox__label {
  color: #333 !important;
}
.answer_btns .el-checkbox__input {
  display: flex;
  justify-content: center;
  align-items: center;
}
.answer_btns .el-checkbox__inner {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.answer_btns .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #0094ff;
  border-color: #0094ff;
}
.el-message--error {
  top: 50% !important;
}
/* 开关 */
.switch_content {
  width: 186 * @px !important;
  height: 40 * @px !important;
  background: #0f1923;
  border-radius: 4 * @px !important;
  position: absolute !important;
  bottom: 30px !important;
  left: 32 * @px !important;
  z-index: 9 !important;
  // border: 1px solid red;
}
.el-switch {
  height: 20 * @px !important;
  position: absolute !important;
  bottom: 0px !important;
  left: 0px !important;
}
.el-switch__core:after {
  width: 89 * @px !important;
  height: 36 * @px !important;
  background: none !important;
  background: linear-gradient(180deg, #ededed 0%, #9d9d9d 100%) !important;
  border-radius: 4 * @px !important;
}
.el-switch__core {
  width: 90 * @px !important;
  height: 40 * @px !important;
  position: absolute !important;
  top: -20 * @px !important;
  left: 0 * @px !important;
}
.el-switch.is-checked .el-switch__core::after {
  margin-left: 6 * @px !important;
}
.el-switch__label--right {
  margin-left: -5 * @px !important;
}
.el-switch__label {
  width: 90 * @px !important;
  height: 38 * @px !important;
  display: flex !important;
  font-size: 14 * @px !important;
  font-family: Medium !important;
  justify-content: center !important;
  align-items: center !important;
  color: #526374 !important;
  margin-top: -18 * @px !important;
  z-index: 2 !important;
}
.el-switch__label.is-active {
  color: #0f1923 !important;
}
.errorword {
  color: #ff5454 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue